module.exports = __webpack_public_path__ + "static/media/wireframes-03.c944ef6a.png";